import { render, staticRenderFns } from "./popup-processor.vue?vue&type=template&id=a4924a08&scoped=true"
import script from "./popup-processor.vue?vue&type=script&lang=js"
export * from "./popup-processor.vue?vue&type=script&lang=js"
import style0 from "./popup-processor.vue?vue&type=style&index=0&id=a4924a08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4924a08",
  null
  
)

export default component.exports